export function convertDEGToDMS(deg, lat = true) {
    const absolute = Math.abs(deg);
    const degrees = Math.floor(absolute);
    const minutesNotTruncated = (absolute - degrees) * 60;
    const minutes = Math.floor(minutesNotTruncated);
    const seconds = ((minutesNotTruncated - minutes) * 60).toFixed(2);
    return degrees + "°" + minutes + "'" + seconds + "\"" + (lat ? (deg >= 0 ? "N" : "S") : (deg >= 0 ? "E" : "W"));
}
